import LevelService from '../../../../services/level_service';

const Deletes = (props) => {
  const deleteLevel = async (id) => {
    const lostAccess = await props.losesAccess?.();
    if (lostAccess) return;
    if (id.startsWith('temp')) {
      props.setLevels(prev => prev.filter(q => q.Id !== id));
      props.message("Nivel eliminado con exito", "success");
      return;
    }
    props.setLoading(true)
    try {
      const deleted = await LevelService.delete(id);
      if (props.logout(deleted)) return;
      if (deleted) {
        const update = updateNumberLevels(id)
        if(update) props.message("Nivel eliminado con exito", "success");
      }
    } catch(e) {
      props.message(e?.message || e, "error")
    } finally {
      props.setLoading(false)
    }
  }

  const updateNumberLevels = async (id) => {
    try {
      const lostAccess = await props.losesAccess?.();
      if (lostAccess) return false;
      const deletedLevel = props.levels.find(level => level.Id === id);
      const levelsToUpdate = props.levels
        .filter(level => level.Id !== id && level.NumberLevel > deletedLevel.NumberLevel)
        .map(level => ({
          ...level,
          NumberLevel: level.NumberLevel - 1,
          EquivalentActivities: level.EquivalentActivities.length > 0 ?
            (level.EquivalentActivities)
              .map(act => act.text?.trim())
              .filter(text => text)
              .join('-') : null
        }));
      const updates = await LevelService.updates(levelsToUpdate)
      if (props.logout(updates)) return false;
      props.setLevels(prev => {
        const filtered = prev.filter(level => level.Id !== id);
        return filtered.map(level =>
          level.NumberLevel > deletedLevel.NumberLevel
            ? { ...level, NumberLevel: level.NumberLevel - 1 }
            : level
        );
      });
      return true
    } catch(e) {
      props.message(e?.message || e, "error")
      return false
    }
  }

  const deleteActivity = async (levelId, activityId) => {
    try {
      props.setLoading(true);
      const lostAccess = await props.losesAccess?.();
      if (lostAccess) return;
      const currentLevel = props.levels.find(level => level.Id === levelId);
      const updatedActivities = (currentLevel.EquivalentActivities || [])
        .filter(activity => activity.Id !== activityId);
      const updatedLevel = {
        ...currentLevel,
        EquivalentActivities: updatedActivities
          .map(activity => activity.text?.trim())
          .filter(text => text)
          .join('-')
      };
      const response = await LevelService.updates([updatedLevel]);
      if (props.logout(response)) return;
      props.setLevels(prevLevels =>
        prevLevels.map(level =>
          level.Id === levelId
            ? {
                ...level,
                EquivalentActivities: updatedActivities
              }
            : level
        )
      );
      props.message("Actividad eliminada con éxito", "success");
    } catch (e) {
      props.message(e?.message || e, "error");
    } finally {
      props.setLoading(false);
    }
  };

  return {
    deleteLevel,
    deleteActivity
  }  
}

export default Deletes;
